import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var findReplacePluginKey = new PluginKey('findReplace');